import { TableColumnMeta } from "ds/components/Table/types";

export const INTENT_PROJECT_RESOURCES_TABLE_STORAGE_KEY = "intent-project-resources-table";
export const INTENT_PROJECT_RESOURCES_LIMIT_STORAGE_KEY = "intent-project-resources-limit";
export const INTENT_PROJECT_RESOURCES_LIMIT = 50;
export const INTENT_PROJECT_RESOURCES_TABLE_FILTERS_STORAGE_KEY =
  "intent-project-resources-table-filters";

export const INTENT_PROJECT_PAGINATION_OPTIONS = [10, 25, 50];

export const INTENT_PROJECT_MODULE_RESOURCES_PER_PAGE = 50;

export enum INTENT_PROJECT_RESOURCES_COLUMN_ID {
  PROVIDER = "PROVIDER",
  RESOURCE_TYPE = "RESOURCE_TYPE",
  RESOURCE_ID = "RESOURCE_ID",
  ROW_ACTIONS = "ROW_ACTIONS",
}

const MAX_CELL_WIDTH = 2000;

export const INTENT_PROJECT_RESOURCES_COLUMN_CONFIG: Record<
  INTENT_PROJECT_RESOURCES_COLUMN_ID,
  TableColumnMeta
> = {
  [INTENT_PROJECT_RESOURCES_COLUMN_ID.RESOURCE_ID]: {
    id: INTENT_PROJECT_RESOURCES_COLUMN_ID.RESOURCE_ID,
    title: "Resource ID",
    minWidth: 180,
    defaultWidth: 180,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: false,
    resizable: true,
    canHide: true,
    canPin: true,
    canMove: true,
  },
  [INTENT_PROJECT_RESOURCES_COLUMN_ID.RESOURCE_TYPE]: {
    id: INTENT_PROJECT_RESOURCES_COLUMN_ID.RESOURCE_TYPE,
    title: "Resource Type",
    minWidth: 190,
    defaultWidth: 190,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: false,
    resizable: true,
    canHide: true,
    canPin: true,
    canMove: true,
  },

  [INTENT_PROJECT_RESOURCES_COLUMN_ID.PROVIDER]: {
    id: INTENT_PROJECT_RESOURCES_COLUMN_ID.PROVIDER,
    title: "Provider",
    minWidth: 180,
    defaultWidth: 180,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: false,
    resizable: true,
    canHide: true,
    canPin: true,
    canMove: true,
  },
  [INTENT_PROJECT_RESOURCES_COLUMN_ID.ROW_ACTIONS]: {
    id: INTENT_PROJECT_RESOURCES_COLUMN_ID.ROW_ACTIONS,
    title: "Actions",
    noHeader: true,
    minWidth: 60,
    defaultWidth: 60,
    maxWidth: 60,
    allowsSorting: false,
    resizable: false,
    canHide: false,
    configurable: false,
    canPin: false,
    canMove: false,
  },
};
